<template>
   <div class="container">
        <div class="flats-items-section" :class="'flats-items-section-' + flatsListView">
            <div class="flats-item" v-for="item in flatsItems" :class="'flats-view-' + flatsListView">
                <router-link :to="{ name: 'flats-card' , params:{'id' : item.id}}">
                    <div class="item-content-grid" v-if="flatsListView == 'grid'"> 
                        <div class="grid-head">
                            <div class="item-title">
                                <span v-if="item.rooms.label != 'ст'">{{ item.rooms.label }} {{ filterCMSparams.words_translation.flats_card_title }}</span>
                                <span v-else>{{ filterCMSparams.words_translation.studiya }}</span>
                            </div>
                            <div class="head-value value-project">{{ item.project.name }}</div>
                            <div class="head-value value-part">{{ parseMultiLangPart(item.part.label) }}</div>
                        </div>
                        <div class="item-img">
                            <img :src="item.plan" alt="" v-if="item.plan != null && item.plan != ''">
                            <svgIcon name="none-img" class="icon-none-img" v-else/>
                        </div>
                        <div class="item-info">
                            <div class="info-value">{{ item.size }} <span>м²</span></div>
                            <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                        </div>
                    </div>
                    <div class="item-head-mobile" v-if="flatsListView == 'list' && isMobileChecker">
                        <div class="info-value info-value-price">{{ getNumber(item.price_full) }} тг</div>
                        <div class="info-value info-value-project">{{ item.project.name }}</div>
                        <div class="info-value info-value-part">{{ parseInt(item.part.label) }} {{ filterCMSparams.words_translation.part }}</div>
                        <div class="value-item-img">
                            <img :src="item.plan" alt="" v-if="item.plan != null && item.plan != ''">
                            <svgIcon name="none-img" class="icon-none-img" v-else/>
                        </div>
                    </div>
                    <div class="item-content-list" v-if="flatsListView == 'list'">
                        <ul>
                            <li v-if="!isMobileChecker">
                                <div class="item-img">
                                    <img :src="item.plan" alt="" v-if="item.plan != null && item.plan != ''">
                                    <svgIcon name="none-img" class="icon-none-img" v-else/>
                                </div>
                            </li>
                            <li>
                                <div class="info-value">
                                    <span v-if="item.rooms.value == '0'">Студия</span>
                                    <span v-if="item.rooms.value == '1'">{{ item.rooms.label }} комната</span>
                                    <span v-if="item.rooms.value != '0' && item.rooms.value != '1'">{{ item.rooms.label }} комнаты</span>
                                </div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value info-value-project">{{ item.project.name }}</div>
                            </li>
                            <li>
                                <div class="info-value">{{ item.class.name }}</div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value">{{ parseInt(item.part.label) }}</div>
                            </li>
                            <li>
                                <div class="info-value size-value">{{ item.size }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                            <li v-if="!isMobileChecker">
                                <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                            </li>
                        </ul>
                    </div>
                    <div class="favorite-item">
                        <div class="btn-link" @click.prevent="sendToFavorite(item), toogleActiveClass($event)" :class="{'active' : checkIfFavorite(item)}">
                            <svgIcon name="favorite-disactive" class="icon-favorite"/>
                            <svgIcon name="favorite-active" class="icon-favorite-active"/>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'flats-items-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            filterCMSparams: 'loadFilterCMSparams',
            flatsItems: 'loadFlatsItems',
            flatsItemsDefault: 'loadFlatsItemsDefault',
            flatsItemsAnimate: 'loadFlatsItemsAnimate',
            flatsListView: 'loadFlatsListView',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            sendToFavorite(arr) {
                // console.log(arr)
                var favorites = JSON.parse(localStorage.getItem('favorite_flats_dial')) || [];
                var finder = this.checkIfFavorite(arr); // проверка наличия объекта в массиве избранных
                if (!finder) { // Добавляем объект в массив если такого объекта не обнаружено в массиве
                    favorites.push(arr);
                    localStorage.setItem('favorite_flats_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                } else { // Убираем из массива если такой объект уже есть в избранном
                    favorites = favorites.filter(favorite => favorite.id != arr.id);
                    localStorage.setItem('favorite_flats_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                    // console.log(favorites, 'asdasdasdasdasd')
                }
            },
            checkIfFavorite(arr) { // проверка наличия объекта в массиве избранных
                var favorites = JSON.parse(localStorage.getItem('favorite_flats_dial')) || [];
                var finder = favorites.some(favorite => favorite.id === arr.id); 
                return finder;
            },
            toogleActiveClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            parseMultiLangPart(str) {
                if (this.globalLang != 'kz/') {
                    return str
                } else {
                    const num = parseInt(str.match(/\d+/)[0]);
                    const word = ' кезек';
                    return num + word;
                }
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-items.scss';
    @import '@/styles/components/flats-page/respond/flats-items-respond.scss';
</style>